"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArrayOfLength = exports.isArray = void 0;
var _isDefined = require("../misc-checks/isDefined");
var _isOfLength = require("../misc-checks/isOfLength");
/**
 * Tests argument to see if it is an Array object
 *
 * @name isArray
 * @param {argument} Argument to test
 * @returns {boolean} Result of Array test
 */
const isArray = targetArray => {
  return (0, _isDefined.isDefined)(targetArray) && typeof targetArray === "object" && Object.prototype.hasOwnProperty.call(targetArray, "length");
};

/**
 * Tests argument to see if it is an Array object with length
 *
 * @name isArrayOfLength
 * @param {argument} Argument to test
 * @returns {boolean} Result of Array and Array length tests
 */
exports.isArray = isArray;
const isArrayOfLength = targetArray => {
  return isArray(targetArray) && (0, _isOfLength.isOfLength)(targetArray);
};
exports.isArrayOfLength = isArrayOfLength;